import React, { Component } from "react";
import { Grid, Row, Col, Modal, InputGroup } from "react-bootstrap";
import auth from "../../../services/authService";
import Select from "../../../components/Common/select";
import * as itemService from "../../../services/itemServices";
import Input from "../../../components/Common/input";
import Checkbox from "../../../components/Common/checkbox";
import * as formatService from "../../../services/formatServices";
import Textarea from "../../../components/Common/textarea";
import LightBox from "../../../components/Common/lightbox";
import Loader from "react-loader-spinner";
import Datetime from "react-datetime";
import { qcImg } from "../../../services/config.json";
import imageCompression from "browser-image-compression";

var base64 = require("base-64");
class QCSurface extends Component {
  state = {
    data: {
      group: "",
      code: "",
      stuffing_date:"",
      dateFrom:"",
      dateTo:"",
      transaction_date:"",
      customer_code: "",
      gambar_qc_surface: "",
      qty: 0,
      titik: [],
      surface: [],
      detail: [],
    },
    content: { item: "" },
    items: [],
    eItems: [],
    openModalItem: false,
    openModalNotif: false,
    openModalUpdate: false,
    isOpen: false,
    image: "",
    uploading: false,
    selectedFile: null,
    allowFile: false,
    titik: [],
    selectedIndex: -1,
    selectedDimensi: -1,
    currentOpenModalUpload: false,
    selectedSurface: -1,
    status: [
      { label: "Pending", value: "1" },
      { label: "Approved", value: "2" },
      { label: "Declined", value: "-1" },
    ],
    isProcessed: false,
  };
  handleChangeDate = (e, target) => {
    if (typeof e === "object") {
      let datetime = e.format("YYYY-MM-DD");
      const data = { ...this.state.data };
      data[target] = datetime;
      if (this.mount) {
        this.setState({ data });
      }
    } else {
      const data = { ...this.state.data };
      data[target] = "";
      if (this.mount) {
        this.setState({ data });
      }
    }
  };
  handleSelectedFoto = async (event, idx) => {
    const { selectedIndex, selectedSurface } = this.state;
    console.log("selectedindex : " + selectedIndex, idx);
    if (event.target.files[0]) {
      if (selectedIndex >= 0 && selectedSurface >= 0) {
        let data = { ...this.state.data };
        let surface = [...data.surface[selectedIndex].foto];
        let item = { ...surface[selectedSurface] };
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(
          event.target.files[0],
          options
        );
        item.file = compressedFile;
        surface[selectedSurface] = item;
        data.surface[selectedIndex].foto = surface;
        if (this.mount) {
          this.setState({ data });
        }
      }
    }
  };
  handleSelectedFotoTitik = async (event, idx) => {
    const { selectedIndex, selectedSurface } = this.state;
    console.log("selectedindex : " + selectedIndex, idx);
    if (event.target.files[0]) {
      if (selectedIndex >= 0 && selectedSurface >= 0) {
        let data = { ...this.state.data };
        let titik = [...data.titik[selectedIndex]];
        let item = { ...titik[selectedSurface] };
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(
          event.target.files[0],
          options
        );
        item.file = compressedFile;
        titik[selectedSurface] = item;
        data.titik[selectedIndex] = titik;
        if (this.mount) {
          this.setState({ data });
        }
      }
    }
  };
  handleDeleteFotoTitik = (index) => {
    const { selectedIndex } = this.state;
    // console.log(selectedIndex, index);
    if (selectedIndex >= 0 && index >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[selectedIndex]];
      const temp = titik.filter((s, idx) => idx !== index);
      // titik[selectedIndex] = temp;
      data.titik[selectedIndex] = temp;
      if (this.mount) this.setState({ data });
    }
  };
  handleSelectedFile = async (event) => {
    const { selectedIndex, selectedDimensi } = this.state;
    if (selectedIndex >= 0 && selectedDimensi >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[selectedIndex]];
      let item = { ...titik[selectedDimensi] };
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(
        event.target.files[0],
        options
      );
      item.file = compressedFile;
      titik[selectedDimensi] = item;
      data.titik[selectedIndex] = titik;
      if (this.mount) {
        this.setState({ data });
      }
    }
    // this.setState({
    //   selectedFile: event.target.files[0],
    //   allowFile: this.checkExt(event.target.files[0].name)
    // });
  };
  handleChangeNumberTitik = (val, index, target) => {
    const { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let data = { ...this.state.data };
      let titik = [...data.titik[selectedIndex]];
      let item = { ...titik[index] };
      item[target] = val.formattedValue;
      titik[index] = item;
      data.titik[selectedIndex] = titik;
      if (this.mount) {
        this.setState({ data });
      }
    }
  };

  handleChangeDetail = ({ currentTarget: input }, target) => {
    const { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let data = { ...this.state.data };
      let detail = { ...data.detail[selectedIndex] };
      detail[target] = input.value;
      if (target === "status" && input.value == 2) {
        detail.is_show = false;
      }
      data.detail[selectedIndex] = detail;
      if (this.mount) {
        this.setState({ data });
      }
    }
  };
  // handleChangeTitik = ({ currentTarget: input }, index, target) => {
  //   let titik = [...this.state.titik];
  //   let item = { ...titik[index] };
  //   item[target] = input.value;
  //   titik[index] = item;
  //   if (this.mount) {
  //     this.setState({ titik });
  //   }
  // };
  handleChangeNumber = (val, target) => {
    const data = { ...this.state.data };
    data[target] = val.formattedValue;
    if (this.mount) {
      this.setState({ data });
    }
  };
  checkExt(val) {
    let temp = val.substring(val.length - 4);
    temp = temp.replace(".", "");
    let acceptable = false;
    if (
      temp.toLowerCase() === "jpg" ||
      temp.toLowerCase() === "png" ||
      temp.toLowerCase() === "jpeg" ||
      temp.toLowerCase() === "pdf"
    ) {
      acceptable = true;
    }
    return acceptable;
  }
  getData = async () => {
    let tempEItem = [];
    const { data } = this.state;
    await itemService.getQCSurfaceReport(data).then((data) => {
      const temp = { ...this.state.data };
      const tempItem = data.item
        ? data.item.map((item, idx) => {
            return { ...item, is_show: true };
          })
        : [];
      if (data.item) {
        for (var i = 0; i < data.item.length; i++) {
          const eItemIdx = this.checkLocalItem(data.item[i].id_item, tempEItem);
          console.log(eItemIdx);
          if (eItemIdx < 0) {
            tempEItem = [...tempEItem, { ...data.item[i], jumlah: 1 }];
          } else {
            tempEItem[eItemIdx].jumlah += 1;
          }
        }
      }
      const tempSur = data.surface ? data.surface : [];
      for (var i = 0; i < tempSur.length; i++) {
        const foto = tempSur[i].foto.map((s, idx) => {
          return { ...s, status: s.status === "0" ? false : true };
        });
        tempSur[i].foto = foto;
      }

      temp.surface = data.surface ? [...tempSur] : [];
      temp.titik = data.dimensi ? data.dimensi : [];
      temp.detail = tempItem;
      this.setState({
        data: temp,
        eItems: tempEItem,
      });
    });
  };
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    if (this.mount) {
      this.setState({ data });
    }
  };
  componentDidMount() {
    this.mount = true;
    this.baseData = this.state.data;
    if (localStorage.getItem('sGroup')) {
      const data = { ...this.state.data };
      data.group = localStorage.getItem('sGroup');
      data.stuffing_date = localStorage.getItem('sStuffing') ?localStorage.getItem('sStuffing'): "";
      if (this.mount) {
        this.setState({ data }, () =>{
          this.getData();
          localStorage.removeItem('sGroup');
          localStorage.removeItem('sStuffing');
        });
      }
    }
  }
  componentWillUnmount() {
    this.mount = false;
  }
  handleUpload = () => {
    this.setState({ openModalUpdate: true });
  };
  handleShowImage = (image) => {
    if (this.mount)
      this.setState({ image, isOpen: true, openModalUpload: false });
  };
  closeLightBox = () => {
    const { currentOpenModalUpload } = this.state;
    if (this.mount)
      this.setState({ isOpen: false, openModalUpload: currentOpenModalUpload });
  };

  handleAddItem = async (item) => {
    const eItemIdx = this.checkItemsIdx(item.id_item);
    const { eItems } = this.state;
    await itemService.getItemById(item.id_item).then((data) => {
      const temp = { ...this.state.data };
      // let temps = data.dimensi
      //   ? data.dimensi.map((dimensi) => {
      //       return {
      //         ...dimensi,
      //         nilai: 0,
      //         titik_image: "",
      //         file: null,
      //       };
      //     })
      //   : [];
      let foto = [];
      let qty = 1;
      const tqty = parseInt(formatService.removeString(temp.qty), 10);
      if (tqty >= 2 && tqty <= 25) {
        qty = 2;
      } else if (tqty >= 26 && tqty <= 150) {
        qty = 3;
      } else if (tqty >= 151 && tqty <= 1200) {
        qty = 5;
      } else if (tqty >= 1201 && tqty <= 35000) {
        qty = 8;
      } else if (tqty >= 35001) {
        qty = 13;
      }
      for (var i = 0; i < qty; i++) {
        foto = [
          ...foto,
          { file: null, surface_file: "", status: true, keterangan: "" },
        ];
      }
      let tempsur = { jumlah_foto: 1, foto };
      let tempdetail = {
        id_item: item.id_item,
        code: item.code,
        gambar_qc_surface: item.gambar_qc_surface ? item.gambar_qc_surface : "",
        customer_code: item.customer_code,
        qc_notes: item.qc_notes ? item.qc_notes : "",
        grup: "",
        pesan_barang: "",
        status: "1",
        is_show: true,
      };
      let tempTitik = [...this.state.data.titik, []];
      let surface = [...this.state.data.surface, tempsur];
      let detail = [...this.state.data.detail, tempdetail];
      temp.titik = tempTitik;
      temp.surface = surface;
      temp.detail = detail;
      this.setState(
        {
          data: temp,
          eItems:
            eItemIdx >= 0 ? eItems : [...eItems, { ...tempdetail, jumlah: 1 }],
        },
        () => {
          this.props.createNotification(
            "success",
            "1 Item berhasil ditambahkan !"
          );
          this.countJumlahItem();
        }
      );
    });
  };
  handleAddFoto = () => {
    let { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let tempFoto = {
        file: null,
        surface_file: "",
        status: true,
        keterangan: "",
      };
      let foto = [...this.state.data.surface[selectedIndex].foto, tempFoto];
      const data = { ...this.state.data };
      data.surface[selectedIndex].foto = foto;
      this.setState({ data });
    }
  };
  handleDeleteFoto = (index) => {
    const { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      const data = { ...this.state.data };
      data.surface[selectedIndex].foto[index].file = null;
      data.surface[selectedIndex].foto[index].surface_file = "";
      if (this.mount) this.setState({ data });
    }
  };

  handleAddTitik = () => {
    let { selectedIndex } = this.state;
    if (selectedIndex >= 0) {
      let tempFoto = {
        file: null,
        surface_file: "",
        nama: "",
        keterangan: "",
      };
      let foto = [...this.state.data.titik[selectedIndex], tempFoto];
      const data = { ...this.state.data };
      data.titik[selectedIndex] = foto;
      this.setState({ data });
    }
  };

  handleDeleteTitik = (index) => {
    const data = { ...this.state.data };
    const titik = data.titik.filter((s, idx) => idx !== index);
    const surface = data.surface.filter((s, idx) => idx !== index);
    const detail = data.detail.filter((s, idx) => idx !== index);
    data.titik = titik;
    data.surface = surface;
    data.detail = detail;
    if (this.mount)
      this.setState({ data, selectedIndex: -1, selectedDimensi: -1 }, () => {
        this.countJumlahItem();
      });
  };
  handleOpenModalUpload = (idx) => {
    this.setState({
      currentOpenModalUpload: true,
      openModalUpload: true,
      selectedDimensi: idx,
    });
  };

  isPdf(val) {
    let pdf = false;
    if (val && val !== "" && val !== undefined) {
      let temp = val.substring(val.length - 4);
      temp = temp.replace(".", "");
      if (temp.toLowerCase() === "pdf") {
        pdf = true;
      }
    }
    return pdf;
  }
  handleOpenPdf = (link) => {
    window.open(link);
  };
  getItem = async () => {
    const { content } = this.state;
    await itemService.getItemQcForModal(content.item).then((data) => {
      console.log(data);
      if (data.item !== null) {
        this.setState({ items: data.item });
      }
    });
  };
  handleOpenModalItem = () => {
    this.getItem();
    this.setState({ openModalItem: true });
  };
  handleChangeContent = ({ currentTarget: input }) => {
    const content = { ...this.state.content };
    content[input.name] = input.value;
    if (this.mount) {
      this.setState({ content });
    }
  };
  handleSubmit = (e, target) => {
    if (e.key === "Enter") {
      if (target === "item") {
        this.getItem();
      }
    }
  };

  showItem = (id_item) => {
    const { data } = this.state;
    for (var i = 0; i < data.detail.length; i++) {
      if (data.detail[i].id_item == id_item) {
        data.detail[i].is_show = true;
      }
    }
    this.setState({ data });
  };
  countJumlahItem = () => {
    const { data, eItems } = this.state;
    for (var i = 0; i < eItems.length; i++) {
      eItems[i].jumlah = 0;
      for (var j = 0; j < data.detail.length; j++) {
        if (eItems[i].id_item == data.detail[j].id_item) eItems[i].jumlah++;
      }
    }
    this.setState({ eItems });
  };
  checkLocalItem = (id_item, items) => {
    let idx = -1;
    for (var i = 0; i <= items.length; i++) {
      if (items[i] && items[i].id_item == id_item) {
        idx = i;
        break;
      }
    }
    return idx;
  };
  checkItemsIdx = (id_item) => {
    const { eItems } = this.state;
    let idx = -1;
    for (var i = 0; i <= eItems.length; i++) {
      if (eItems[i] && eItems[i].id_item == id_item) {
        idx = i;
        break;
      }
    }
    return idx;
  };
  handleHideDetail = (index) => {
    let data = { ...this.state.data };
    let detail = { ...data.detail[index] };
    detail.is_show = !detail.is_show;
    data.detail[index] = detail;
    if (this.mount) {
      this.setState({ data });
    }
  };
  handleChangeSurface = ({ currentTarget: input }, index, idx, target) => {
    // const { selectedIndex } = this.state;
    // if (selectedIndex >= 0) {
    // data.surface[index].foto
    let data = { ...this.state.data };
    let surface = [...data.surface[index].foto];
    let item = { ...surface[idx] };
    item[target] = input.value;
    surface[idx] = item;
    data.surface[index].foto = surface;
    if (this.mount) {
      this.setState({ data });
    }
    // }
  };
  handleChangeTitik = ({ currentTarget: input }, index, idx, target) => {
    // const { selectedIndex } = this.state;
    // if (selectedIndex >= 0) {
    // data.surface[index].foto
    let data = { ...this.state.data };
    let titik = [...data.titik[index]];
    let item = { ...titik[idx] };
    item[target] = input.value;
    titik[idx] = item;
    data.titik[index] = titik;
    if (this.mount) {
      this.setState({ data });
    }
    // }
  };
  handleToggleCheckbox = (val, index, idx, target) => {
    // const { selectedIndex } = this.state;
    // if (selectedIndex >= 0) {
    // data.surface[index].foto
    let data = { ...this.state.data };
    let surface = [...data.surface[index].foto];
    let item = { ...surface[idx] };
    item[target] = !item[target];
    surface[idx] = item;
    data.surface[index].foto = surface;
    if (this.mount) {
      this.setState({ data });
    }
    // }
  };
  render() {
    const {
      data,
      openModalUpdate,
      uploading,
      isOpen,
      image,
      openModalNotif,
      openModalUpload,
      selectedIndex,
      selectedDimensi,
      selectedSurface,
      status,
      isProcessed,
      items,
      openModalItem,
      content,
      eItems,
    } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={9}>
              <div className="card">
                <div className="content">
                  <Row>
                    <Col md={4}>
                      <Input
                        onChange={this.handleChange}
                        value={data.group}
                        name="group"
                        label="Group"
                      />
                    </Col>
                    <Col md={4}>
                      <div className="form-group">
                        <label>Stuffing Date</label>
                        <Datetime
                          timeFormat={false}
                          dateFormat={"DD-MM-YYYY"}
                          inputProps={{ placeholder: "Tanggal Stuffing" }}
                          value={
                            data.stuffing_date ? new Date(data.stuffing_date) : ""
                          }
                          onChange={(e) => this.handleChangeDate(e, "stuffing_date")}
                        />
                      </div>
                    </Col>
                    {/* <Col md={8}>
                      <div className="form-group">
                        <label>Stuffing Date</label>
                        <InputGroup>
                          <Datetime
                            timeFormat={false}
                            dateFormat={"DD-MM-YYYY"}
                            inputProps={{ placeholder: "Dari" }}
                            value={
                              data.dateFrom ? new Date(data.dateFrom) : ""
                            }
                            onChange={(e) => this.handleChangeDate(e, "dateFrom")}
                          />
                          <InputGroup.Addon>
                            <i className="fa fa-minus" />
                          </InputGroup.Addon>
                          <Datetime
                            timeFormat={false}
                            dateFormat={"DD-MM-YYYY"}
                            inputProps={{ placeholder: "Sampai" }}
                            value={data.dateTo ? new Date(data.dateTo) : ""}
                            onChange={(e) => this.handleChangeDate(e, "dateTo")}
                          />
                        </InputGroup>
                      </div>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col md={7}>
                      {eItems &&
                        eItems.map((item, idx) => (
                          <React.Fragment key={idx}>
                            {item.jumlah > 0 && (
                              <Row key={idx}>
                                <Col
                                  md={12}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.showItem(item.id_item)}
                                >
                                  {item.code} - {item.customer_code} :{" "}
                                  {item.jumlah} Pcs
                                </Col>
                              </Row>
                            )}
                          </React.Fragment>
                        ))}
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <button
                        className="btn btn-fill btn-primary"
                        onClick={() => this.getData()}
                      >
                        Search
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col md={9}>
              {data.detail &&
                data.detail.map((titik, index) => (
                  <div
                    className="card"
                    key={index}
                    onMouseDown={() => {
                      this.setState({ selectedIndex: index });
                    }}
                    style={{
                      display: data.detail[index].is_show ? "block" : "none",
                    }}
                  >
                    <div className="content">
                      <Row>
                        <Col md={8}>
                          <label style={{ fontSize: "25px" }}>{`${index + 1}. ${
                            data.detail[index].code
                          } - ${data.detail[index].customer_code}`}</label>
                          <label style={{ fontSize: "23px" }}>
                            Group : {data.detail[index].group} / Stuffing Date : {data.detail[index].stuffing_date}
                          </label>
                        </Col>
                        <Col md={4} style={{ textAlign: "right" }}>
                          <button
                            className="btn btn-fill btn-secondary"
                            style={{ marginRight: "5px", fontWeight: "bold" }}
                            onClick={() => this.handleHideDetail(index)}
                          >
                            _
                          </button>
                          {/* <button
                            className="btn btn-fill btn-danger"
                            onClick={() => this.handleDeleteTitik(index)}
                          >
                            <i className="fa fa-trash"></i>
                          </button> */}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          {data.detail[index].gambar_qc_surface !== "" && (
                            <React.Fragment>
                              {!this.isPdf(
                                data.detail[index].gambar_qc_surface
                              ) ? (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "155px",
                                    border: "1px solid black",
                                    position: "relative",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    margin: "0",
                                  }}
                                >
                                  <img
                                    alt=""
                                    style={{
                                      display: "block",
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      maxHeight: "100%",
                                      maxWidth: "100%",
                                      transform: "translate(-50%, -50%)",
                                      cursor: "pointer",
                                    }}
                                    src={`${qcImg}${data.detail[index].gambar_qc_surface}`}
                                    onClick={() =>
                                      this.handleShowImage(
                                        `${qcImg}${data.detail[index].gambar_qc_surface}`
                                      )
                                    }
                                  />
                                </div>
                              ) : (
                                <div>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      paddingRight: "15px",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: "justify",
                                        width: "100px",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      <a
                                        style={{
                                          display: "block",
                                          margin: "0 auto",
                                          width: "100%",
                                          maxWidth: "100px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          this.handleOpenPdf(
                                            `${qcImg}${data.detail[index].gambar_qc_surface}`
                                          )
                                        }
                                      >
                                        {data.detail[index].gambar_qc_surface}{" "}
                                      </a>
                                    </div>
                                  </span>
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </Col>
                        <Col md={6}>
                          <div dangerouslySetInnerHTML={{__html:data.detail[index].qc_notes}}></div>
                        </Col>
                      </Row>
                      <Row>
                        <React.Fragment>
                          <Col md={8}>
                            <Row>
                              <Col md={4}>
                                <Input
                                  onChange={(e) =>
                                    this.handleChangeDetail(e, "pesan_barang")
                                  }
                                  value={data.detail[index].pesan_barang}
                                  name="pesan_barang"
                                  label="Pesan Barang"
                                  disabled={true}
                                  onFocus={() =>
                                    this.setState({ selectedIndex: index })
                                  }
                                />
                              </Col>
                              <Col md={6}>
                                <Select
                                  label="Status"
                                  onChange={(e) =>
                                    this.handleChangeDetail(e, "status")
                                  }
                                  options={status}
                                  optionValue="value"
                                  optionLabel="label"
                                  name="status"
                                  disabled={true}
                                  value={data.detail[index].status}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col md={12}>
                                <label>Surface</label>
                              </Col>
                              {data.surface[index].foto &&
                                data.surface[index].foto.map((foto, idx) => (
                                  <Col
                                    md={3}
                                    key={idx}
                                    // onMouseEnter={() => {
                                    //   // this.setState({
                                    //   //   selectedSurface: idx,
                                    //   // });
                                    //   // console.log(idx);
                                    // }}
                                  >
                                    <input
                                      style={{ display: "none" }}
                                      type="file"
                                      name="uploadFoto"
                                      id="uploadFoto"
                                      onChange={(e) =>
                                        this.handleSelectedFoto(e, idx)
                                      }
                                    />
                                    <Row>
                                      <Col md={2}>
                                        <div
                                          style={{
                                            // width: "25%",
                                            // float: "left",
                                            height: "75px",
                                          }}
                                        >
                                          {idx + 1}.
                                          <Checkbox
                                            onChange={(e) =>
                                              this.handleToggleCheckbox(
                                                e,
                                                index,
                                                idx,
                                                "status"
                                              )
                                            }
                                            disabled={true}
                                            isChecked={foto.status}
                                            id={`status${index}${idx}`}
                                            name={`status${index}${idx}`}
                                          />
                                        </div>
                                      </Col>
                                      <Col md={9}>
                                        <div
                                          style={{
                                            // width: "75%",
                                            height: "75px",
                                            border: "1px solid black",
                                            position: "relative",
                                            display: "inline-block",
                                            overflow: "hidden",
                                            margin: "0",
                                            display: foto.status
                                              ? "none"
                                              : "block",
                                          }}
                                        >
                                          {/* <i
                                            className="fa fa-trash"
                                            style={{
                                              fontSize: "15px",
                                              cursor: "pointer",
                                              zIndex: "100",
                                              position: "relative",
                                              top: "-5%",
                                            }}
                                            onClick={() =>
                                              this.handleDeleteFoto(idx)
                                            }
                                          /> */}
                                          {foto.file ? (
                                            <img
                                              alt=""
                                              style={{
                                                display: "block",
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                maxHeight: "100%",
                                                maxWidth: "100%",
                                                transform:
                                                  "translate(-50%, -50%)",
                                                cursor: "pointer",
                                              }}
                                              src={URL.createObjectURL(
                                                foto.file
                                              )}
                                              onClick={() =>
                                                this.handleShowImage(
                                                  URL.createObjectURL(foto.file)
                                                )
                                              }
                                            />
                                          ) : (
                                            <React.Fragment>
                                              {foto.surface_file ? (
                                                <img
                                                  alt=""
                                                  style={{
                                                    display: "block",
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    maxHeight: "100%",
                                                    maxWidth: "100%",
                                                    transform:
                                                      "translate(-50%, -50%)",
                                                    cursor: "pointer",
                                                  }}
                                                  src={`${qcImg}${foto.surface_file}`}
                                                  onClick={() =>
                                                    this.handleShowImage(
                                                      `${qcImg}${foto.surface_file}`
                                                    )
                                                  }
                                                />
                                              ) : (
                                                <label
                                                  style={{
                                                    top: "20%",
                                                    left: "20%",
                                                    position: "relative",
                                                    fontSize: "25px",
                                                    cursor: "pointer",
                                                  }}
                                                  htmlFor="uploadFoto"
                                                  onClick={() => {
                                                    this.setState({
                                                      selectedSurface: idx,
                                                    });
                                                    // console.log(idx);
                                                  }}
                                                >
                                                  <i className="fa fa-camera" />
                                                </label>
                                              )}
                                            </React.Fragment>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={12}>
                                        <Input
                                          onChange={(e) =>
                                            this.handleChangeSurface(
                                              e,
                                              index,
                                              idx,
                                              "keterangan"
                                            )
                                          }
                                          disabled={true}
                                          value={foto.keterangan}
                                          name="keterangan"
                                          label="Note"
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                ))}
                              <Col md={2}>
                                {/* <div
                                  style={{
                                    width: "100%",
                                    height: "75px",
                                    border: "1px solid black",
                                  }}
                                >
                                  <i
                                    className="fa fa-plus"
                                    style={{
                                      top: "40%",
                                      left: "40%",
                                      position: "relative",
                                      fontSize: "25px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => this.handleAddFoto()}
                                  ></i>
                                </div> */}
                              </Col>
                            </Row>
                          </Col>
                          <Col md={4}>
                            <input
                              style={{ display: "none" }}
                              type="file"
                              name="uploadFotoT"
                              id="uploadFotoT"
                              onChange={(e) => this.handleSelectedFotoTitik(e)}
                            />
                            {data.titik[index] &&
                              data.titik[index].map((t, idx) => (
                                <Row key={idx}>
                                  <Col md={12}>
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "75px",
                                        border: "1px solid black",
                                        position: "relative",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        margin: "0",
                                      }}
                                    >
                                      {/* <i
                                        className="fa fa-trash"
                                        style={{
                                          fontSize: "15px",
                                          cursor: "pointer",
                                          zIndex: "100",
                                          position: "relative",
                                          top: "-5%",
                                        }}
                                        onClick={() =>
                                          this.handleDeleteFotoTitik(idx)
                                        }
                                      /> */}
                                      {t.file ? (
                                        <img
                                          alt=""
                                          style={{
                                            display: "block",
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            maxHeight: "100%",
                                            maxWidth: "100%",
                                            transform: "translate(-50%, -50%)",
                                            cursor: "pointer",
                                          }}
                                          src={URL.createObjectURL(t.file)}
                                          onClick={() =>
                                            this.handleShowImage(
                                              URL.createObjectURL(t.file)
                                            )
                                          }
                                        />
                                      ) : (
                                        <React.Fragment>
                                          {t.surface_file ? (
                                            <img
                                              alt=""
                                              style={{
                                                display: "block",
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                maxHeight: "100%",
                                                maxWidth: "100%",
                                                transform:
                                                  "translate(-50%, -50%)",
                                                cursor: "pointer",
                                              }}
                                              src={`${qcImg}${t.surface_file}`}
                                              onClick={() =>
                                                this.handleShowImage(
                                                  `${qcImg}${t.surface_file}`
                                                )
                                              }
                                            />
                                          ) : (
                                            <label
                                              style={{
                                                top: "20%",
                                                left: "20%",
                                                position: "relative",
                                                fontSize: "25px",
                                                cursor: "pointer",
                                              }}
                                              htmlFor="uploadFotoT"
                                              onClick={() => {
                                                this.setState({
                                                  selectedSurface: idx,
                                                });
                                                // console.log(idx);
                                              }}
                                            >
                                              <i className="fa fa-camera" />
                                            </label>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={12}>
                                    <Input
                                      onChange={(e) =>
                                        this.handleChangeTitik(
                                          e,
                                          index,
                                          idx,
                                          "nama"
                                        )
                                      }
                                      disabled={true}
                                      value={t.nama}
                                      name="nama"
                                      label="Name"
                                    />
                                  </Col>
                                  <Col md={12}>
                                    <Input
                                      onChange={(e) =>
                                        this.handleChangeTitik(
                                          e,
                                          index,
                                          idx,
                                          "keterangan"
                                        )
                                      }
                                      disabled={true}
                                      value={t.keterangan}
                                      name="keterangan"
                                      label="Note"
                                    />
                                  </Col>
                                </Row>
                              ))}
                            <Row>
                              <Col md={12}>
                                {/* <div
                                  style={{
                                    width: "100%",
                                    height: "75px",
                                    border: "1px solid black",
                                  }}
                                >
                                  <i
                                    className="fa fa-plus"
                                    style={{
                                      top: "40%",
                                      left: "40%",
                                      position: "relative",
                                      fontSize: "25px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => this.handleAddTitik()}
                                  ></i>
                                </div> */}
                                {/* <Input
                              onValueChange={e =>
                                this.handleChangeSurfaceNumber(
                                  e,
                                  index,
                                  "jumlah_foto"
                                )
                              }
                              value={data.surface[index].jumlah_foto}
                              name="jumlah_foto"
                              label="Jumlah Foto"
                            /> */}
                              </Col>
                            </Row>
                          </Col>
                        </React.Fragment>
                      </Row>
                    </div>
                  </div>
                ))}
            </Col>
            {/* <Row>
              <Col md={9} style={{ textAlign: "right" }}>
                <button
                  className="btn btn-fill btn-primary"
                  onClick={() => this.handleUpload()}
                >
                  Update
                </button>
              </Col>
            </Row> */}
          </Row>
        </Grid>
        <Modal
          bsSize="small"
          show={openModalUpdate}
          onHide={() => this.setState({ openModalUpdate: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update QC</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Proceed Update ?</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalUpdate: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
            <button
              onClick={() => this.handleProceed()}
              className="btn btn-fill btn-success"
              disabled={isProcessed}
            >
              Proceed
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          bsSize="small"
          show={openModalUpload}
          onHide={() =>
            this.setState({
              openModalUpload: false,
              currentOpenModalUpload: false,
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Gambar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <input
                    style={{ display: "none" }}
                    type="file"
                    name="uploadFile"
                    id="uploadFile"
                    onChange={this.handleSelectedFile}
                  />
                  Upload Image [{" "}
                  <label
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    htmlFor="uploadFile"
                  >
                    UPLOAD
                  </label>{" "}
                  ]
                  {selectedIndex >= 0 &&
                    selectedDimensi >= 0 &&
                    data.titik[selectedIndex][selectedDimensi].file && (
                      <div>
                        <img
                          alt=""
                          style={{
                            display: "block",
                            margin: "0 auto",
                            width: "100%",
                            maxWidth: "100px",
                            cursor: "pointer",
                            float: "left",
                          }}
                          src={URL.createObjectURL(
                            data.titik[selectedIndex][selectedDimensi].file
                          )}
                          onClick={() =>
                            this.handleShowImage(
                              URL.createObjectURL(
                                data.titik[selectedIndex][selectedDimensi].file
                              )
                            )
                          }
                        />
                      </div>
                    )}
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() =>
                this.setState({
                  openModalUpload: false,
                  currentOpenModalUpload: false,
                })
              }
              className="btn btn-fill btn-secondary"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          bsSize="small"
          show={openModalNotif}
          onHide={() => this.setState({ openModalNotif: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>Gambar belum di upload !</Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => this.setState({ openModalNotif: false })}
              className="btn btn-fill btn-secondary"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
        <LightBox
          isOpen={isOpen}
          images={image}
          closeLightBox={this.closeLightBox}
        />
        {uploading && (
          <div style={{ position: "absolute", top: "50vh", left: "50%" }}>
            <Loader type="Circles" color="#00BFFF" height="50" width="50" />
          </div>
        )}
      </div>
    );
  }
}

export default QCSurface;



// WEBPACK FOOTER //
// ./src/views/qc/surface/update.jsx